import { AREA_LIST_PANEL_CONFIGS, AreaListPanelKey } from "~/modules/plannerV2/constants/areaListPanelConfig";

import { PlannerV2AreasScreenAreaFragment } from "../../queries.generated";

export function getDefaultOpenPanel(
    areasByPanel: Record<string, PlannerV2AreasScreenAreaFragment[]>,
): AreaListPanelKey | null {
    for (const config of AREA_LIST_PANEL_CONFIGS) {
        const areasInPanel = areasByPanel[config.key];
        if (areasInPanel && areasInPanel.length > 0) {
            return config.key;
        }
    }

    return null;
}
